import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AlertsService } from '../../services/alerts.service';
import { AsideBarService } from '../../services/asideBar.service';
import { BaseService } from '../../shared/services/base.service';
import { AsideUiEngineComponent } from '../aside-ui-engine/aside-ui-engine.component';

@Component({
    selector: 'data-grid-row-edit',
    templateUrl: './data-grid-row-edit.component.html',
    styleUrls: ['./data-grid-row-edit.component.scss'],
    standalone: false
})
export class DataGridRowEditComponent implements OnInit {
  _currentData: any = {};
  modalRef: BsModalRef;
  @Input() resource: string;
  @Input() config: any;
  @Output() gridData = new EventEmitter<any>();

  constructor(public route: ActivatedRoute, public baseService: BaseService, public commonService: AsideBarService, public alerts: AlertsService) { }

  ngOnInit() {
    this._currentData.json = this.resource != undefined && this.resource ? this.resource : this.route.snapshot.params.resource;
    this._currentData.showAddButton = true;
    this.getResource();
  }
  //setting the resource and initiating component
  getResource() {
    this.baseService.getResourceDef(this._currentData.json, (resouceDef) => {
      if (resouceDef) {
        this._currentData.currentResource = resouceDef.resource;
        this._currentData.currentListFields = resouceDef.list.fields;
        this._currentData.dataList = this.config.data;
        this._currentData.asideGridConfig = resouceDef.aside_grid_config != undefined ? resouceDef.aside_grid_config : {};
        if (resouceDef.list && resouceDef.list.gridButtons != undefined) {
          if (this._currentData.currentListFields.find(elem => (elem.name == 'gridButton')) == undefined) {
            resouceDef.list.gridButtons.name = "gridButton";
            this._currentData.currentListFields.push(resouceDef.list.gridButtons);
          }
        }
        this.setGridConfig(resouceDef.list);
      }
    });
  }
  //hiding searchbox and pagination add further config here
  setGridConfig(config) {
    var dataGridConfig = JSON.parse(JSON.stringify(config));
    delete dataGridConfig.filter;
    delete dataGridConfig.fields;
    delete dataGridConfig.bulkAction;
    this._currentData['dataGridConfig'] = config;
  }

  //this will call ui engine or perform the actions like delete copy etc
  setComponent(event) {
    if (this.config.disableGrid != undefined ? !this.config.disableGrid : true) {
      switch (event.actionType.action_name) {
        case 'MODIFY':
        case 'ADD':
        case 'VIEW':
          this.setAsideBar(event);
          break;
        case 'COPY':
          this.copyRow(event);
          break;
        case 'DELETE':
          this.deleteRow(event);
          break;
      }
    }
    else {
      this.alerts.error(this._currentData.asideGridConfig.error_message != undefined ? this._currentData.asideGridConfig.error_message : "Not Allowed");
    }


  }
  onSubmit(btn) {
    let res = { data: this._currentData.dataList.resource, submitButton: btn };
    this.gridData.emit(res);
  }

  setAsideBar(event) {
    this._currentData.showAddButton = false;
    if (document.getElementById('cstmOverlay') && document.getElementById('cstmOverlay').classList.value.includes("d-none")) { this.commonService.classToggler('cstmOverlay'); }
    event['resource'] = this._currentData.json;
    let componentConfig = {
      inputs: {
        data: event
      }
    };
    this.commonService.appendComponentTo('aside-modal-container', AsideUiEngineComponent, componentConfig).subscribe(data => {
      if (data) {
        this._currentData.showAddButton = true;
        switch (data.data.action) {
          case 'MODIFY':
            Object.assign(this._currentData.dataList.resource[data.data.index], data.data.result);
            break;
          case 'ADD':
            this._currentData.dataList.resource.unshift(data.data.result);
            break;
        }

      }
    });
  }

  copyRow(event) {
    let data = JSON.parse(JSON.stringify(this._currentData.dataList.resource));
    this._currentData.dataList.resource.splice(event.index + 1, 0, data[event.index]);
  }
  deleteRow(event) {
    let data = this._currentData.dataList.resource;
    data.splice(event.index, 1);
  }
  addRow(action) {
    let obj = { 'actionType': { 'action_name': action } };
    this.setComponent(obj);
  }
  onBulkActionClicked(data) { }
  bindDataToGrid(e){}
}
